<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">My bundle was missing a component</h1>

			<div v-if="condition !== 'exchange'">

				<h3 v-if="comps.length">The list of components:</h3>
				<ul class="h-bundle-components" v-if="comps.length">
					<li v-for="comp in comps">
						<v-flex xs12>
							<v-card color="" class="">
								<v-layout>
									<v-flex xs2>
										<v-img
												:src="comp.cover"
												height="90px"
												contain
												class="mt-2"
										></v-img>
									</v-flex>
									<v-flex xs9>
										<v-card-title primary-title>
											<div>
												<div class="">{{ comp.title }}</div>
												<div>{{ comp.author }}</div>
												<div>{{ comp.component_isbn }}</div>
											</div>
										</v-card-title>
									</v-flex>
									<v-flex xs1>
										<v-layout align-center justify-center>
											<v-checkbox hide-details class="shrink mr-2" v-model="comp.checked"></v-checkbox>
										</v-layout>
									</v-flex>
								</v-layout>
								<v-divider light></v-divider>
							</v-card>
						</v-flex>
					</li>
				</ul>

				<div v-if="!comps.length">
					<p>
						Unfortunately we have no record of that item being a bundle. It's possible that we just missed it though. Let us know in the field below
						what you think was missing
					</p>

					<email-form
							subject="My bundle was missing a component"
							:body="email_body"
							on-success-url="/help?#/submitted"
							edit-body
							must-edit
							:payload="{ order_line_id }"
							destination-key="cs"
					></email-form>
				</div>

				<v-checkbox label="A book was missing that isn’t showing" v-model="something_else" v-if="comps.length"></v-checkbox>
				<v-textarea
						v-if="something_else && comps.length"
						v-model="missing_books"
						label="ISBNs or Titles of missing books (each in separate line)"
						solo
						flat
				></v-textarea>
				<v-btn color="#7DADED" large round dark v-if="missing_books || selected_items.length > 0" @click="submit">Send a Report of missing books</v-btn>

				<v-dialog
						v-model="ac_selected"
						width="500"
				>
					<v-card>
						<v-card-title
								class="headline grey lighten-2"
								primary-title
						>
							You have selected an Access Code
						</v-card-title>

						<v-card-text>
							Please ensure that the access code is not lodged in the front cover, back cover, or inside of the book.
						</v-card-text>

						<v-divider></v-divider>

						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn
									color="primary"
									flat
									@click="ac_selected = false"
							>
								Ok
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</div>
			<div v-else>
				<v-flex xs12 class="mb-3">
					<v-card>
						<v-card-title primary-title>
							<div>
								<h3>Seller's comment:</h3>
								<div>{{ comment ? comment : 'no comment' }}</div>
							</div>
						</v-card-title>
					</v-card>
				</v-flex>

				<p>
					Marketplace items are not guaranteed to contain supplements. If the seller advised that you should have received something that you didn't,
					<a :href="`/account/new_messages.php?action=thread&type=postsale&item_id=${parseInt($route.params.id)}#lastmessage`">send the seller an
						email</a>.
					If there are any issues let us know.
				</p>

				<p v-if="!spoke_to_seller">
					<v-btn @click="spoke_to_seller = true">I spoke to the seller and they didn't resolve the issue</v-btn>
				</p>

				<email-form
						caption="Contact Us"
						v-if="spoke_to_seller"
						subject="I spoke to the seller and they didn't resolve the issue"
						:body="email_body_mp"
						on-success-url="/help?#/submitted"
						edit-body
						must-edit
						:payload="{ order_line_id }"
						destination-key="cs"
				></email-form>

			</div>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import BaseNavLinks from './../../components/BaseNavLinks';
	import EmailForm from './../../components/EmailForm';
	import Axios from 'axios';
	import _ from 'lodash';

	export default {
		name: "BundleMissesComponent",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				loading: false,
				loaded: false,
				something_else: false,
				ac_selected: false,
				missing_books: '',
				comps: [],
				condition: null,
				comment: null,
				spoke_to_seller: false,
				order_id: null,
				order_line_id: null,
			}
		},

		mounted() {
			const self = this;
			self.loading = true;

			Axios.get('/service/customer_help/rest/index.php/customer_help/get_bundle_components/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data) {
						self.condition = response['data']['data']['condition'];
						self.comment = response['data']['data']['comments'];
						self.order_id = response['data']['data']['order_id'];
						self.order_line_id = response['data']['data']['order_line_id'];

						self.comps = _.map(response['data']['data']['bundle'], function (v) {
							v['checked'] = false;
							return v;
						});

						if (self.comps.length === 0) {
							self.something_else = true;
						}
					}
				})
				.finally(function () {
					self.loading = false;
				});
		},

		computed: {
			selected_items() {
				const self = this;
				return _.filter(self.comps, x => x.checked);
			},

			is_checked_access_code() {
				const self = this;
				return _.filter(self.comps, x => x.checked && x.component_description === 'access card').length > 0;
			},

			email_body() {
				return `Hello, my bundle was missing components but you don't have a record of this item being a bundle. I believe it should also contain the following:\n\n\nCan you please look into it?\n`;
			},

			email_body_mp() {
				return `I received a marketplace item and the components didn't match the seller description. I messaged the seller and they didn't resolve the issue. Can you look into this?`;
			},
		},

		watch: {
			is_checked_access_code(val) {
				if (val) {
					this.ac_selected = true;
				}
			}
		},

		methods: {
			submit() {
				const self = this;
				self.loading = true;

				Axios.post('/service/customer_help/rest/index.php/customer_help/send_bundle_missing_components_cs_request/', {
					order_line_id: parseInt(self.$route.params.id),
					missing_isbns: _.concat(_.map(self.selected_items, x => x['component_isbn']), (self.something_else ? self.missing_books.split("\n") : []))
				})
					.then(function (response) {
						if (response.status === 200 && response.data) {
							self.$router.push('/submitted');
						}
					})
					.finally(function () {
						self.loading = false;
					});
			}
		}

	}
</script>

<style scoped lang="less">
	ul.h-bundle-components {
		padding: 0;

		> li {
			list-style: none;
		}
	}
</style>